// extracted by mini-css-extract-plugin
export default {"container":"bOeTXy","pills-container":"jcae_H","pill-icon":"EFYWOV"};